<template>
  <div
    class="product__zenit-background"
    :class="{ 'product__zenit-background--loading': loading }">
      <!-- image -->
      <div
        v-if="!loading"
        class="product__zenit-background__img">
        <p
          v-if="productHasTagNews"
          class="product__zenit-background__productHasTagNews">
            {{ $t('common.newProduct') }}
        </p>
        <h1>{{ currentProduct.fields.title }}</h1>
        <picture v-lazy-container="{ selector: 'img' }">
          <source media="(min-width: 1200px)" :srcset="srcSetImages['original']">
          <source media="(min-width: 1024px)" :srcset="srcSetImages['1024']">
          <source :srcset="srcSetImages['original'] + ' 2x, ' + srcSetImages['640'] + ' 1x'" />
          <img
            style="width:auto;"
            :class="{ 'product__zenit-background__img--loaded': imageLoaded }"
            :data-src="srcSetImages['640']"
            :data-loading="lazyLoading"
            :alt="currentProduct.fields.mainPicture.fields.description"
            @load="imageLoaded = true">
        </picture> 
        <!--
        <img
          :src="currentProduct.fields.mainPicture.fields.file.url"
          :alt="currentProduct.fields.mainPicture.fields.description"
          :width="currentProduct.fields.mainPicture.fields.file.details.image.width"
          :height="currentProduct.fields.mainPicture.fields.file.details.image.height">
        -->
      </div>
      <!-- icons -->
      <div
        v-if="typeof iconsTags !== 'undefined'"
        class="product__zenit-background__content__icons">
        <ul>
          <li
            v-for="(iconTag, index) of iconsTags"
            :key="index">
              <img
                :src="iconTag.fields.tagIcon.fields.file.url"
                :alt="iconTag.fields.title"
                :width="iconTag.fields.tagIcon.fields.file.details.image.width"
                :height="iconTag.fields.tagIcon.fields.file.details.image.height">
              <strong>{{ iconTag.fields.title }}</strong>
          </li>
        </ul>
      </div>
      <!-- features -->
      <div
        v-if="!loading"
        class="product__zenit-background__content">
        <div class="product__zenit-background__content__features">
          <div class="product__zenit-background__content__features__column product__zenit-background__content__features__column--features1" v-html="features"></div>
          <div class="product__zenit-background__content__features__column product__zenit-background__content__features__column--features2" v-html="features2"></div>
          <div class="product__zenit-background__content__features__row" v-html="features3"></div>
        </div>
      </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { documentToHtmlString } from '@contentful/rich-text-html-renderer'

export default {
  data: () => ({
    loading: true,
    lazyLoading: require('@/assets/lazy/product-zenit.png'),
    imageLoaded: false
  }),
  props: {
    slug: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters('contentful', [
      'product'
    ]),
    currentProduct: {
      get () {
        return this.product(this.slug)
      }
    },
    features: {
      get () {
        return !this.loading ? documentToHtmlString(this.currentProduct.fields.features) : ''
      }
    },
    features2: {
      get () {
        return !this.loading ? documentToHtmlString(this.currentProduct.fields.features2) : ''
      }
    },
    features3: {
      get () {
        return !this.loading ? documentToHtmlString(this.currentProduct.fields.features3) : ''
      }
    },
    productHasTagNews: {
      get () {
        if (this.loading) return false
        if (typeof this.currentProduct.fields.tags === 'undefined') return false
        return this.currentProduct.fields.tags.some(tag => tag.sys.id === '13RpBAab2koSygiyMGUEUE')
      }
    },
    iconsTags: {
      get () {
        if (this.loading) return undefined
        if (typeof this.currentProduct.fields.tags === 'undefined') return undefined
        const iconsTagsArray = this.currentProduct.fields.tags.filter(tag => typeof tag.fields.tagIcon !== 'undefined')
        if (iconsTagsArray.length === 0) return undefined
        return iconsTagsArray.sort((a, b) => a - b)
      }
    },
    srcSetImages: {
      get () {
        if (this.loading) return undefined
        return {
          '640': `${this.currentProduct.fields.mainPicture.fields.file.url}?w=640&fit=scale`,
          '1024': `${this.currentProduct.fields.mainPicture.fields.file.url}?w=1024&fit=scale`,
          'original': this.currentProduct.fields.mainPicture.fields.file.url
        }
      }
    },
  },
  created () {
    this.loadData()
  },
  methods: {
    ...mapActions('contentful', [
      'loadProducts'
    ]),
    async loadData () {
      this.loading = true
      try {
        await this.loadProducts()
        this.loading = false
      } catch (e) {
        // TODO sentry
      }
    }
  }
}
</script>

<style lang="scss">
  @import "./text.scss";
  @import "./background.scss";
</style>
